"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const app_1 = require("./app");
const responseError = require("./common/responseError");
const storeToken_1 = require("./storeToken");
const getUsers_1 = require("./getUsers");
function loginWithEmail(context) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const { email, password, role } = context;
            let { domainId } = context;
            try {
                const data = yield app_1.app.auth.signInWithEmailAndPassword(email, password);
                const { displayName, providerData, refreshToken, uid } = data.user;
                if (!domainId) {
                    domainId = yield getDomainId({ email, role });
                }
                const tokenData = {
                    refreshToken,
                    uid,
                    name: displayName,
                    email,
                    domainId,
                    providerId: providerData[0].providerId,
                    role
                };
                return yield storeToken_1.default(tokenData, password);
            }
            catch (error) {
                throw new Error(error.code);
            }
        }
        catch (e) {
            throw new responseError.HttpsError(responseError.FunctionsErrorCode.invalid_argument, e.message);
        }
    });
}
exports.default = loginWithEmail;
function getDomainId({ email, role }) {
    return __awaiter(this, void 0, void 0, function* () {
        let domainId = '';
        const userDocs = yield getUsers_1.default({ email, role });
        if (userDocs.length) {
            for (const permission of userDocs[0].permissions) {
                // set domainId from permissions array for matching role
                if (permission.role === role) {
                    domainId = permission.domainId;
                }
            }
        }
        return domainId;
    });
}
//# sourceMappingURL=loginWithEmail.js.map